import { render, staticRenderFns } from "./PhoneUI.vue?vue&type=template&id=4b1db6f8"
import script from "./PhoneUI.vue?vue&type=script&lang=js"
export * from "./PhoneUI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports